import React from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

function CustomAlert(props) {
  const handleConfirmationClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    props.setOpenAlert(false);
  };

  const alertMessage = props.alertText || "Undefined Alert";
  const duration = 2500 + alertMessage.length * 30;
  return (
    <Snackbar
      open={props.openAlert}
      autoHideDuration={duration}
      onClose={handleConfirmationClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ marginTop: "40px" }}
    >
      <Alert
        variant="filled"
        icon={false}
        onClose={handleConfirmationClose}
        sx={{
          width: "100%",
          fontSize: "x-large",
          backgroundColor: props.backgroundColor || "darkslategray",
          border: "solid 5px",
          borderColor: "black",
          borderRadius: "25px",
        }}
      >
        {alertMessage}
      </Alert>
    </Snackbar>
  );
}

export default CustomAlert;

CustomAlert.propTypes = {
  alertText: PropTypes.string,
  openAlert: PropTypes.bool,
  setOpenAlert: PropTypes.func,
  backgroundColor: PropTypes.string,
};
